import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-button-sm',
  templateUrl: './save-button-sm.component.html',
  styleUrls: ['./save-button-sm.component.scss']
})
export class SaveButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
